import styled from "styled-components";
import { BRAND, GRAY_LIGHT, WHITE } from "@streeteasy/design-system/colors";
import { SecondarySmall } from "@streeteasy/design-system/typography";

import { smallScreen } from "src/shared/constants/screenSizes";

export const Text = styled(SecondarySmall).attrs({
  as: "h4"
})`
  color: ${BRAND};
`;

export const Container = styled.div`
  display: flex;
  justify-content: center;
  margin: 0 -12px;
  padding: 39px 0 20px;
  text-align: center;

  @media screen and (max-width: ${smallScreen}px) {
    align-items: center;
    flex-direction: column;
    margin: 0;
    padding: 38px 0 0;
  }
`;

export const Card = styled.div`
  border: 1px solid ${GRAY_LIGHT};
  margin: 12px;
  max-width: 420px;
  padding: 0 15px 16px;
  position: relative;
  width: 100%;

  @media screen and (max-width: ${smallScreen}px) {
    max-width: 420px;
    margin-bottom: 34px;
    margin-left: 0;
    margin-right: 0;
  }
`;

export const Link = styled.a`
  bottom: 0;
  font-size: 0;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
`;

export const Icon = styled.div`
  align-items: center;
  background: ${WHITE};
  border: 1px solid ${GRAY_LIGHT};
  border-radius: 50%;
  display: flex;
  height: 64px;
  justify-content: center;
  margin: -32px auto 11px;
  width: 64px;
`;
